import './helpers.js';
import { f as VueComponentMixin, B as BaseComponentMixin, e as registerComponent, u as use } from './plugins-4daf8ef8.js';
import { openBlock, createBlock, withKeys, withModifiers, withDirectives, createVNode, vModelCheckbox, renderSlot, createCommentVNode } from 'vue';

const modelValueDef = [String, Number, Boolean];
/**
 * Switch between two opposing states
 * @displayName Switch
 * @example ./examples/Switch.md
 * @style _switch.scss
 */

var script = {
  name: 'OSwitch',
  mixins: [VueComponentMixin({
    vModel: modelValueDef
  }), BaseComponentMixin],
  emits: ['update:modelValue'],
  props: {
    /**
     * Same as native value
     */
    nativeValue: [String, Number, Boolean],
    disabled: Boolean,

    /**
     * Color of the switch, optional
     * @values primary, info, success, warning, danger, and any other custom color
     */
    variant: String,

    /**
    * Color of the switch when is passive, optional
    * @values primary, info, success, warning, danger, and any other custom color
    */
    passiveVariant: String,

    /** Name attribute on native checkbox */
    name: String,
    required: Boolean,

    /**
     * Vertical size of switch, optional
     * @values small, medium, large
     */
    size: String,

    /**
     * Overrides the returned value when it's checked
     */
    trueValue: {
      type: [String, Number, Boolean],
      default: true
    },

    /**
     * Overrides the returned value when it's not checked
     */
    falseValue: {
      type: [String, Number, Boolean],
      default: false
    },

    /** Rounded style */
    rounded: {
      type: Boolean,
      default: true
    },

    /** Outlined style */
    outlined: {
      type: Boolean,
      default: false
    },
    rootClass: String,
    disabledClass: String,
    checkClass: String,
    roundedClass: String,
    outlinedClass: String,
    labelClass: String,
    sizeClass: String,
    variantClass: String,
    passiveVariantClass: String,
    animationClass: String
  },

  data() {
    const vm = this;
    return {
      newValue: vm.getModel(),
      isMouseDown: false
    };
  },

  computed: {
    rootClasses() {
      return [this.computedClass('switch', 'rootClass', 'o-switch'), {
        [`${this.computedClass('switch', 'sizeClass', 'o-size-')}${this.size}`]: this.size
      }, {
        [this.computedClass('switch', 'disabledClass', 'o-switch-disabled')]: this.disabled
      }, {
        [this.computedClass('switch', 'roundedClass', 'o-switch-rounded')]: this.rounded
      }, {
        [this.computedClass('switch', 'outlinedClass', 'o-switch-outlined')]: this.outlined
      }];
    },

    checkClasses() {
      return [this.computedClass('switch', 'checkClass', 'o-switch-check'), {
        [this.computedClass('switch', 'animationClass', 'o-switch-elastic')]: this.isMouseDown && !this.disabled
      }, {
        [`${this.computedClass('switch', 'variantClass', 'o-color-')}${this.variant}`]: this.variant
      }, {
        [`${this.computedClass('switch', 'passiveVariantClass', 'o-color-')}${this.passiveVariant}-passive`]: this.passiveVariant
      }];
    },

    labelClasses() {
      return [this.computedClass('switch', 'labelClass', 'o-switch-label')];
    },

    computedValue: {
      get() {
        return this.newValue;
      },

      set(value) {
        this.newValue = value;
        this.emitModel(value);
      }

    }
  },
  methods: {
    /**
    * When v-model change, set internal value.
    */
    onModelChange(value) {
      this.newValue = value;
    },

    focus() {
      // MacOS FireFox and Safari do not focus when clicked
      this.$refs.input.focus();
    }

  }
};

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_ctx.vueReady)
    ? (openBlock(), createBlock("label", {
        key: 0,
        class: $options.rootClasses,
        ref: "label",
        disabled: $props.disabled,
        onClick: _cache[3] || (_cache[3] = (...args) => ($options.focus(...args))),
        onKeydown: _cache[4] || (_cache[4] = withKeys(withModifiers($event => (_ctx.$refs.label.click()), ["prevent"]), ["enter"])),
        onMousedown: _cache[5] || (_cache[5] = $event => ($data.isMouseDown = true)),
        onMouseup: _cache[6] || (_cache[6] = $event => ($data.isMouseDown = false)),
        onMouseout: _cache[7] || (_cache[7] = $event => ($data.isMouseDown = false)),
        onBlur: _cache[8] || (_cache[8] = $event => ($data.isMouseDown = false))
      }, [
        withDirectives(createVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ($options.computedValue = $event)),
          type: "checkbox",
          ref: "input",
          onClick: _cache[2] || (_cache[2] = withModifiers(() => {}, ["stop"])),
          disabled: $props.disabled,
          name: $props.name,
          required: $props.required,
          value: $props.nativeValue,
          "true-value": $props.trueValue,
          "false-value": $props.falseValue
        }, null, 8 /* PROPS */, ["disabled", "name", "required", "value", "true-value", "false-value"]), [
          [vModelCheckbox, $options.computedValue]
        ]),
        createVNode("span", { class: $options.checkClasses }, null, 2 /* CLASS */),
        createVNode("span", { class: $options.labelClasses }, [
          renderSlot(_ctx.$slots, "default")
        ], 2 /* CLASS */)
      ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, ["disabled"]))
    : createCommentVNode("v-if", true)
}

script.render = render;
script.__file = "oruga/src/components/switch/Switch.vue";

const Plugin = {
  install(Vue) {
    registerComponent(Vue, script);
  }

};
use(Plugin);

export default Plugin;
export { script as OSwitch };
